module.exports = __webpack_public_path__ + "static/app-formato-beneficiario-1-4812991b4840f6d2368b92d068c9dc9e.svg";